module.exports = __webpack_public_path__ + "assets/img/index_plat_one.01197e85.png";